import { useQuery } from '@apollo/client';
import { Link } from 'react-router';
import { graphql } from '~/apollo/generated/v4';
import { NoItemsAlert } from '~/components/common/NoItemsAlert';
import { NotFound } from '~/components/common/NotFound';
import { PageHeading } from '~/components/common/PageHeading';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { useRouteParam } from '~/hooks/routing';
import { outcropTourDetailRoute } from '~/paths';

const OUTCROP_TOUR_PAGE = graphql(`
  query OutcropTourPage($outcropId: ID!) {
    outcropGet(id: $outcropId) {
      id
      outcropTours {
        id
        name
        lifecycleStatus
      }
    }
  }
`);

export default function OutcropTourPage() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_TOUR_PAGE, {
    variables: { outcropId },
  });

  const outcrop = data?.outcropGet;
  const tours = outcrop?.outcropTours ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <div>
      <PageHeading>Outcrop Tours</PageHeading>

      <div className="space-y-2">
        <NoItemsAlert show={tours.length === 0} entity="outcrop tour" />

        {tours.map(tour => (
          <div key={tour.id} className="card shadow">
            <div className="card-body">
              <div className="flex items-center justify-between">
                <div className="text-lg font-semibold">{tour.name}</div>
                <div className="flex space-x-2">
                  <Link
                    to={outcropTourDetailRoute(outcropId, parseInt(tour.id))}
                    className="btn btn-primary btn-sm"
                  >
                    View Tour
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
